import React from 'react';
import { Global } from '@emotion/react';

const HideFreshChat = () => (
  <Global
    styles={`
      #fc_frame:not(.fc-open) {
        display: none;
      }
    `}
  />
);

export default HideFreshChat;
